import { ReactNode } from 'react';
import { Box, Divider, Flex, SimpleGrid, VStack, Text } from '@chakra-ui/react';
import { Footer } from './footer/Footer';
import styles from './Layout.module.scss';
import { Header } from './header/Header';

export type LayoutProps = {
  children?: ReactNode;
};

export const Layout = ({ children }: LayoutProps): JSX.Element => (
  <Flex direction="column" h="100vh">
    <SimpleGrid columns={[1, 1, 1, 2]}>
      <Box display={['none', 'none', 'none', 'block']}>
        <Box className={styles.hero}>
          <Text className={styles.caption} color="white" padding={1}>
            St. Jude patient <strong>Madeline</strong>, pictured with her mom{' '}
            <strong>Miranda</strong>.
          </Text>
        </Box>
      </Box>
      <Box>
        <Header />
        <Box display={['block', 'block', 'block', 'none']}>
          <Box className={styles.hero}>
            <Text className={styles.caption} color="white" padding={1}>
              St. Jude patient <strong>Madeline</strong>, pictured with her mom{' '}
              <strong>Miranda</strong>.
            </Text>
          </Box>
        </Box>
        <VStack
          align="left"
          divider={<Divider />}
          maxW="730px"
          padding={[4, 4, 12]}
          spacing={6}
          w="full"
          maxWidth="570px"
        >
          <Box as="main">{children}</Box>
          <Footer />
        </VStack>
      </Box>
    </SimpleGrid>
  </Flex>
);
